// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  font-size: 13px !important;
}
@media(min-width: 650px){

  .desktopHide {
    display: none !important;
  }

}
/* table width/height */
.tableSizes {
  height: auto;
  max-height: 30vh;
  width: 100%;
  transition: max-height 0.5s ease-in;
 /* margin-top: 10px;*/
}

.tableZoom {
  height: auto;
  max-height: 70vh;
  transition: max-height 0.5s ease-out;
}

.infoTable {
  width: 100%;
}
/*table coloring*/
.infoTable .mat-row:nth-child(odd){
  background-color:#F7F8F9;
}

/*table coloring*/
.infoTable .mat-row:nth-child(even){
  background-color:#F7F8F9;
}
.mat-checkbox-inner-container {
  background-color: #ffd8a7;
}

.infoTable .mat-header-cell {
  background-color: #ffd8a7;
  color: black;
  font-weight: bold;
  padding-right: 5px;
}

.itemsTable .mat-header-cell {
  background-color: lightsalmon;
  color: black;
  font-weight: bold;
}
.itemsTable .mat-row:nth-child(even){
  background-color: #FFF5E3;
}
.itemsTable .mat-row:nth-child(odd){
  background-color: #FFF5E3;
}
.mat-row {
  height: auto;
}

.mat-header-row{
  height: auto;
}

.resizeTable{
  width: 100%; background-color: #ffd8a7; cursor: pointer;
}

.tdHeader {
  font-weight: bold; background-color: #ffd8a7;width: 30%; min-width: 100px; font-size: 13px;
}

.tdRow {
  background-color: #FFF5E3; padding-left: 5px; font-size: 13px;
}
th {
  font-size: 13px !important;
}
td {
  font-size: 13px !important;
}


/* expanded table */
table {
  width: 100%;
}

tr.example-detail-row {
  height: 0;
}

tr.example-element-row:not(.example-expanded-row):hover {
  background: whitesmoke;
}

tr.example-element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.example-element-row td {
  border-bottom-width: 0;
}

.example-element-detail {
  overflow: hidden;
  display: flex;
}

.example-element-diagram {
  min-width: 80px;
  border: 2px solid black;
  padding: 8px;
  font-weight: lighter;
  margin: 8px 0;
  height: 104px;
}

.example-element-symbol {
  font-weight: bold;
  font-size: 40px;
  line-height: normal;
}

.example-element-description {
  padding: 16px;
}

.example-element-description-attribution {
  opacity: 0.5;
}

.mat-column-booked, .mat-column-buildInSolution, .mat-column-communication,
.mat-column-documentId, .mat-column-mailSentTo, .mat-column-nextContact,
.mat-column-orderId, .mat-column-replied, .mat-column-status, .mat-column-worker,
.mat-column-status {
  max-width: 7% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
}

.mat-column-event, .mat-column-text {
  max-width: 14% !important;
  width: auto !important;
  overflow: hidden;
  white-space: nowrap;
}
mat-button-toggle:hover {
  background-color: #ffd8a7 !important;
  color:white;
}

.mat-button-toggle-checked {
    background-color: #ffd8a7 !important;
    color:white;
}
`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/helpdesk-tab/helpdesk-tab.component.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;;EAEE;IACE,wBAAwB;EAC1B;;AAEF;AACA,uBAAuB;AACvB;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mCAAmC;CACpC,qBAAqB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;AACA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,yBAAyB,EAAE,eAAe;AACzD;;AAEA;EACE,iBAAiB,EAAE,yBAAyB,CAAC,UAAU,EAAE,gBAAgB,EAAE,eAAe;AAC5F;;AAEA;EACE,yBAAyB,EAAE,iBAAiB,EAAE,eAAe;AAC/D;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;;AAGA,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf","sourcesContent":["table {\n  font-size: 13px !important;\n}\n@media(min-width: 650px){\n\n  .desktopHide {\n    display: none !important;\n  }\n\n}\n/* table width/height */\n.tableSizes {\n  height: auto;\n  max-height: 30vh;\n  width: 100%;\n  transition: max-height 0.5s ease-in;\n /* margin-top: 10px;*/\n}\n\n.tableZoom {\n  height: auto;\n  max-height: 70vh;\n  transition: max-height 0.5s ease-out;\n}\n\n.infoTable {\n  width: 100%;\n}\n/*table coloring*/\n.infoTable .mat-row:nth-child(odd){\n  background-color:#F7F8F9;\n}\n\n/*table coloring*/\n.infoTable .mat-row:nth-child(even){\n  background-color:#F7F8F9;\n}\n.mat-checkbox-inner-container {\n  background-color: #ffd8a7;\n}\n\n.infoTable .mat-header-cell {\n  background-color: #ffd8a7;\n  color: black;\n  font-weight: bold;\n  padding-right: 5px;\n}\n\n.itemsTable .mat-header-cell {\n  background-color: lightsalmon;\n  color: black;\n  font-weight: bold;\n}\n.itemsTable .mat-row:nth-child(even){\n  background-color: #FFF5E3;\n}\n.itemsTable .mat-row:nth-child(odd){\n  background-color: #FFF5E3;\n}\n.mat-row {\n  height: auto;\n}\n\n.mat-header-row{\n  height: auto;\n}\n\n.resizeTable{\n  width: 100%; background-color: #ffd8a7; cursor: pointer;\n}\n\n.tdHeader {\n  font-weight: bold; background-color: #ffd8a7;width: 30%; min-width: 100px; font-size: 13px;\n}\n\n.tdRow {\n  background-color: #FFF5E3; padding-left: 5px; font-size: 13px;\n}\nth {\n  font-size: 13px !important;\n}\ntd {\n  font-size: 13px !important;\n}\n\n\n/* expanded table */\ntable {\n  width: 100%;\n}\n\ntr.example-detail-row {\n  height: 0;\n}\n\ntr.example-element-row:not(.example-expanded-row):hover {\n  background: whitesmoke;\n}\n\ntr.example-element-row:not(.example-expanded-row):active {\n  background: #efefef;\n}\n\n.example-element-row td {\n  border-bottom-width: 0;\n}\n\n.example-element-detail {\n  overflow: hidden;\n  display: flex;\n}\n\n.example-element-diagram {\n  min-width: 80px;\n  border: 2px solid black;\n  padding: 8px;\n  font-weight: lighter;\n  margin: 8px 0;\n  height: 104px;\n}\n\n.example-element-symbol {\n  font-weight: bold;\n  font-size: 40px;\n  line-height: normal;\n}\n\n.example-element-description {\n  padding: 16px;\n}\n\n.example-element-description-attribution {\n  opacity: 0.5;\n}\n\n.mat-column-booked, .mat-column-buildInSolution, .mat-column-communication,\n.mat-column-documentId, .mat-column-mailSentTo, .mat-column-nextContact,\n.mat-column-orderId, .mat-column-replied, .mat-column-status, .mat-column-worker,\n.mat-column-status {\n  max-width: 7% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n}\n\n.mat-column-event, .mat-column-text {\n  max-width: 14% !important;\n  width: auto !important;\n  overflow: hidden;\n  white-space: nowrap;\n}\nmat-button-toggle:hover {\n  background-color: #ffd8a7 !important;\n  color:white;\n}\n\n.mat-button-toggle-checked {\n    background-color: #ffd8a7 !important;\n    color:white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
